<!-- 服务管理-服务团队-组件级 -->
<template>
  <div class='service'>
    <div class='service-con-wrap'>
      <div class='service-con'>
        <!--CM-->
        <ul class='unconfirm-list'
            v-if='mentorCmList.length > 0'>
          <li v-for='item in mentorCmList'
              :key='item.id'>
            <div class='unconfirm-left-wrap'>
              <div class='unconfirm-left'>
                <img v-if="item.avaurl"
                     :src='item.avaurl' />
                <img v-else
                     src='https://res.zailairen.com/tech/msp/mentor-avatar.svg' />
                <p class='mentor-type'>{{item.mentorType && new Map(mentorRoleCnMap).get(item.mentorType)}}</p>
                <p class='mentor-name'>{{item.mentorName}}</p>
              </div>
            </div>
            <div class='unconfirm-right'>
              <div class='unconfirm-item-wrap'>
                <div class='unconfirm-item'>Undergrad School：{{item.ugdUniver}}</div>
                <div class='unconfirm-item'>Undergrad College/Faculty：{{item.ugdFaculty}}</div>
                <div class='unconfirm-item'>Undergrad Major：{{item.ugdMajor}}</div>
                <div class='unconfirm-item'>Graduate School：{{item.univer}}</div>
                <div class='unconfirm-item'>Graduate Major：{{item.major}}</div>
                <div class='unconfirm-item'>Degree：{{item.degree && new Map(degreeMap).get(item.degree)}}</div>
              </div>
              <div class='unconfirm-oper'>
                <a href='javascript: void(0);'
                   @click="appointMentor(item)">预约导师</a>
              </div>
            </div>
          </li>
        </ul>
        <!--EM-->
        <ul class='unconfirm-list'
            v-if='mentorEmList.length > 0'>
          <li v-for='item in mentorEmList'
              :key='item.id'>
            <div class='unconfirm-left-wrap'>
              <div class='unconfirm-left'>
                <img :src='item.avaurl' />
                <p class='mentor-type'>{{item.mentorType && new Map(mentorRoleCnMap).get(item.mentorType)}}</p>
                <p class='mentor-name'>{{item.mentorName}}</p>
              </div>
            </div>
            <div class='unconfirm-right'>
              <div class='unconfirm-item-wrap'>
                <div class='unconfirm-item'>Undergrad School：{{item.ugdUniver}}</div>
                <div class='unconfirm-item'>Undergrad College/Faculty：{{item.ugdFaculty}}</div>
                <div class='unconfirm-item'>Undergrad Major：{{item.ugdMajor}}</div>
                <div class='unconfirm-item'>Graduate School：{{item.univer}}</div>
                <div class='unconfirm-item'>Graduate Major：{{item.major}}</div>
                <div class='unconfirm-item'>Degree：{{item.degree && new Map(degreeMap).get(item.degree)}}</div>
              </div>
              <div class='unconfirm-oper'>
                <a href='javascript: void(0);'
                   @click="appointMentor(item)">预约导师</a>
              </div>
            </div>
          </li>
        </ul>
        <!--FAO-->
        <ul class='unconfirm-list'
            v-if='mentorFaoList.length > 0'>
          <li v-for='item in mentorCmList'
              :key='item.id'>
            <div class='unconfirm-left-wrap'>
              <div class='unconfirm-left'>
                <img :src='item.avaurl' />
                <p class='mentor-type'>{{item.mentorType && new Map(mentorRoleCnMap).get(item.mentorType)}}</p>
                <p class='mentor-name'>{{item.mentorName}}</p>
              </div>
            </div>
            <div class='unconfirm-right'>
              <div class='unconfirm-item-wrap'>
                <div class='unconfirm-item'>Undergrad School：{{item.ugdUniver}}</div>
                <div class='unconfirm-item'>Undergrad College/Faculty：{{item.ugdFaculty}}</div>
                <div class='unconfirm-item'>Undergrad Major：{{item.ugdMajor}}</div>
                <div class='unconfirm-item'>Graduate School：{{item.univer}}</div>
                <div class='unconfirm-item'>Graduate Major：{{item.major}}</div>
                <div class='unconfirm-item'>Degree：{{item.degree && new Map(degreeMap).get(item.degree)}}</div>
              </div>
              <div class='unconfirm-oper'>
                <a href='javascript: void(0);'
                   @click="appointMentor(item)">预约导师</a>
              </div>
            </div>
          </li>
        </ul>
        <!--导师简介-->
        <ul class='unconfirm-list'>
          <!--sec-->
          <li v-if="hasSEC">
            <div class='unconfirm-left-wrap'>
              <div class='unconfirm-left'>
                <img src='https://res.zailairen.com/tech/msp/mentor-avatar.svg' />
                <p class='mentor-type'>SEC-高级文书顾问</p>
                <p class='mentor-name'>{{chineseTeamList.sec && chineseTeamList.sec.name}}</p>
              </div>
            </div>
            <div class='unconfirm-right'>
              <div class='unconfirm-item-wrap'>
                <div class='base-info-item'>
                  <div class='single-info'>邮箱：{{chineseTeamList.sec && chineseTeamList.sec.email}}</div>
                  <div class='single-info'>电话：{{chineseTeamList.sec && chineseTeamList.sec.phone}}</div>
                  <div class='single-info'>微信：{{chineseTeamList.sec && chineseTeamList.sec.wechat}}</div>
                </div>
                <div class='unconfirm-item'>
                  高级文书顾问是服务过程中与你合作最密切的人之一，可以为你提供的帮助主要包含:<br />
                  带领你进行主文书和附表文书的头脑风暴；<br />
                  对你的活动列表、简历、推荐信、文书进行指导和修改；<br />
                  为你提供与海外文书导师或前招生官参与文书修改及润色的协同对接服务。
                </div>
              </div>
            </div>
          </li>
          <!--se-->
          <li v-if="hasSE">
            <div class='unconfirm-left-wrap'>
              <div class='unconfirm-left'>
                <img src='https://res.zailairen.com/tech/msp/mentor-avatar.svg' />
                <p class='mentor-type'>SE-申请专家</p>
                <p class='mentor-name'>{{chineseTeamList.se && chineseTeamList.se.name}}</p>
              </div>
            </div>
            <div class='unconfirm-right'>
              <div class='unconfirm-item-wrap'>
                <div class='base-info-item'>
                  <div class='single-info'>邮箱：{{chineseTeamList.se && chineseTeamList.se.email}}</div>
                  <div class='single-info'>电话：{{chineseTeamList.se && chineseTeamList.se.phone}}</div>
                  <div class='single-info'>微信：{{chineseTeamList.se && chineseTeamList.se.wechat}}</div>
                </div>
                <div class='unconfirm-item'>
                  申请专家是服务过程中与你合作最密切的人之一，可以为你提供的帮助主要包含:<br />
                  为你进行申请季材料准备的时间规划，讲解并指导申请材料清单；<br />
                  指导你完成标准化考试送分、网申填写、申请结果跟进等工作；<br />
                  为你提供签证申请材料清单及操作步骤，并进行一对一答疑；<br />
                  与你及你的家长及时沟通申请进度，保证你的申请工作顺利进行。
                </div>
              </div>
            </div>
          </li>
          <!--cd-->
          <li>
            <div class='unconfirm-left-wrap'>
              <div class='unconfirm-left'>
                <img v-if="chineseTeamList.cd && chineseTeamList.cd.header"
                     :src='chineseTeamList.cd && chineseTeamList.cd.header' />
                <img v-else
                     src='https://res.zailairen.com/tech/msp/mentor-avatar.svg' />
                <p class='mentor-type'>Coordinator-客户经理</p>
                <p class='mentor-name'>{{chineseTeamList.cd && chineseTeamList.cd.name}}</p>
              </div>
            </div>
            <div class='unconfirm-right'>
              <div class='unconfirm-item-wrap'>
                <div class='base-info-item'>
                  <div class='single-info'
                       style='flex: 2;'>邮箱：{{chineseTeamList.cd && chineseTeamList.cd.email}}</div>
                  <div class='single-info'>电话：{{chineseTeamList.cd && chineseTeamList.cd.phone}}</div>
                  <div class='single-info'>微信：{{chineseTeamList.cd && chineseTeamList.cd.wechat}}</div>
                </div>
                <div class='unconfirm-item'>
                  客户经理是服务过程中与你合作最密切的人之一，可以为你提供的帮助主要包含:<br />
                  为你对接导师团队及全程提供协调；<br />
                  为你进行个性化留学规划方案制定和选校定位；<br />
                  对你的整体申请流程进行把关与申请材料质控；<br />
                  和你共享最新的本科申请案例和留学申请知识；<br />
                  为你提供申请相关的学习资料，服务全过程的咨询以及突发事件处理。
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <team-warn :isShow='hasTimeModal'
               @closeModal='handleTimeCloseModal'>
      <p slot='message'>您已无可用时长，请联系客户经理（CD）额外购买！</p>
    </team-warn> -->
    <div v-if='serviceModal'>
      <service-mentor-modal ref='appointModal'
                            :isShow='serviceModal'
                            defaultWidth='801px'
                            :currMentor='currMentor'
                            :appointModule='appointModule'
                            :hasService='hasService'
                            @appointModalOk='serviceMentorOk'
                            @closeModal='handleCloseModal' />
    </div>
  </div>
</template>

<script>
import serviceMentorModal from './service-mentor-modal'
// import teamWarn from './team-warn'
import defaultMentor from '@/assets/undergraduate/images/default_mentor.png'
import serviceService from '@/api/undergraduate/service'
import { mentorRoleCnMap, degreeMap, packageModule } from '../constantsEnum'
export default {
  name: '',
  components: {
    serviceMentorModal
    // teamWarn
  },
  data () {
    return {
      // 导师临时头像
      defaultMentor,
      // 导师角色映射
      mentorRoleCnMap,
      // degree映射
      degreeMap,
      // 头部页签
      tabList: [
        {
          id: 'unconfirm',
          name: '待确认导师'
        },
        {
          id: 'waiting',
          name: '预约-未开始'
        },
        {
          id: 'complete',
          name: '预约-已完成'
        }
      ],
      // 导师列表CM,EM,FAO
      mentorCmList: [],
      mentorEmList: [],
      mentorFaoList: [],
      // 中方服务团队列表
      chineseTeamList: {
        cd: {},
        se: {},
        sec: {}
      },
      seMentorIntroductionList: [],
      secMentorIntroductionList: [],
      hasSE: false,
      hasSEC: false,
      // 当前一条导师数据
      currMentor: {},
      // 预约套餐可用模块
      appointModule: {},
      // 预约导师弹窗
      serviceModal: false,
      // 预约提交-loading标识
      hasService: false
      // 没有市场情况下弹窗
      // hasTimeModal: false
    }
  },
  computed: {},
  mounted () {
    this.getServiceMentorList()
    this.getMentorIntroductionList()
  },
  methods: {
    // 获取服务团队-导师列表
    getServiceMentorList () {
      serviceService.serviceTeamMentorList().then(res => {
        this.mentorCmList = res.data.cmList
        this.mentorEmList = res.data.emList
        this.mentorFaoList = res.data.faoList
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 获取导师简介列表
    getMentorIntroductionList () {
      serviceService.serviceTeamIntroductionList().then(res => {
        this.chineseTeamList = res.data
        this.hasSE = !!this.chineseTeamList.se
        this.hasSEC = !!this.chineseTeamList.sec
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 预约导师-按钮点击
    appointMentor (item) {
      serviceService.checkHasAppointment({ jointId: item.id }).then(res => {
        this.currMentor = item
        serviceService.serviceTeamMenteeTime({ jointId: item.id }).then(res => {
          let module = Object.entries(res.data.model)
          let tempArr = []
          module.length > 0 && module.map(item => {
            tempArr.push({ id: item[0], checkable: item[1], name: new Map(packageModule).get(item[0]), checked: false })
            return item
          })
          this.appointModule = tempArr
          this.serviceModal = true
        }).catch(res => {
          this.$ugd_message(res.message, 'error')
        })
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 预约导师弹窗-关闭操作
    handleCloseModal () {
      this.serviceModal = false
    },
    // 预约导师弹窗-确认操作
    serviceMentorOk (forms) {
      this.hasService = true
      let data = {
        ...forms,
        jointId: this.currMentor.id
      }
      // 调用接口
      serviceService.serviceTeamAppoint(data).then(res => {
        this.$ugd_message('预约已经提交', 'success')
        this.serviceModal = false
        this.$refs.appointModal.resetState()
        // 调用列表接口
        // this.getServicementMenteeList()
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
      this.hasService = false
    }
    // 无时长弹窗-关闭操作
    // handleTimeCloseModal () {
    //   this.hasTimeModal = false
    // }
  }
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.clearfix {
  *zoom: 1;
  &::after {
    content: "";
    display: block;
    clear: both;
  }
  .fl {
    float: left;
  }
}
.service {
  padding-top: 40px;
  padding-left: 20px;
  .service-con-wrap {
    background: #fff;
    .service-con {
      padding-left: 40px;
      background: #fff;
      padding-bottom: 20px;
      .unconfirm-list {
        li {
          display: flex;
          border-bottom: 1px solid #e6eaf1;
          padding: 30px 0;
          .unconfirm-left-wrap {
            padding: 0 20px;
            flex: 0 0 116px;
            .unconfirm-left {
              width: 118px;
              img {
                width: 80px;
                height: 80px;
                margin: 0 auto;
              }
              .mentor-type {
                padding-top: 20px;
                font-size: 14px;
                color: #323c47;
                letter-spacing: 0;
                text-align: center;
              }
              .mentor-name {
                padding-bottom: 20px;
                font-size: 14px;
                color: #323c47;
                letter-spacing: 0;
                text-align: center;
              }
            }
          }
          .unconfirm-right {
            flex: 1;
            padding-right: 100px;
            .unconfirm-item {
              font-size: 12px;
              color: #667483;
              letter-spacing: 0;
              text-align: justify;
              line-height: 20px;
            }
            .base-info-item {
              display: flex;
              .single-info {
                flex: 1;
                font-size: 12px;
                color: #667483;
                letter-spacing: 0;
                text-align: justify;
                line-height: 20px;
              }
            }
            .unconfirm-oper {
              padding-top: 20px;
              a {
                display: block;
                width: 96px;
                height: 32px;
                background-image: linear-gradient(
                  12deg,
                  #4aa6ff 0%,
                  #4980fd 100%
                );
                border-radius: 8px;
                border-radius: 8px;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 0;
                text-align: center;
                line-height: 32px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
